import { useTheme } from '@material-ui/core';

export const MOBILE_BREAKPOINT = 'xs';

export const useSmallDevice = () => {
  const theme = useTheme();
  const small = window.screen.width < theme.breakpoints.values.sm;
  return { small, theme };
};
